import React, { useState } from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { TeaserCard } from 'Components/frameworks/teaser-card/TeaserCard';
import { truncate } from 'Components/utils/string/string.util';
export type TeaserCardProps = {
  image: string;
  seeMoreLabel?: string;
  subtitle?: string;
  title?: string;
};
type Props = {
  card: TeaserCardProps;
  link: {
    onClick?: () => void;
    url?: string;
  };
};
export const TeaserCardsCard = ({ card, link = {} }: Props) => {
  const { image, seeMoreLabel, subtitle, title } = card;
  const [isHovering, setHovering] = useState(false);
  const { isDesktop } = useResponsive();
  const TagName = link.url ? DynamicLink : 'button';
  return (
    <TagName
      {...link}
      className="tap-highlight-color-transparent text-initial relative block w-full"
      data-testid="TeaserCard"
      onMouseEnter={isDesktop ? () => setHovering(true) : null}
      onMouseLeave={isDesktop ? () => setHovering(false) : null}
    >
      <TeaserCard
        className="w-full"
        isActive={isHovering}
        media={[
          {
            src: image,
          },
        ]}
      >
        <div className="flex flex-col gap-10 py-20">
          {!!title && <p className="text-center text-16 font-bold">{truncate(title, 35, true)}</p>}
          {!!subtitle && (
            <p className="text-center font-sans text-14 font-normal leading-normal text-black">
              {truncate(subtitle, 65, true)}
            </p>
          )}
          {!!seeMoreLabel && <p className="text-center text-12 underline">{seeMoreLabel}</p>}
        </div>
      </TeaserCard>
    </TagName>
  );
};
